import { CONTACT_TYPES, EMAIL_REGEX, EMAILMPLUS_FAKE_REGEX, MOV_REGEX, TYPE_N3 } from '@/constants/constants';
import { PRODUCT_OFFERING_TYPES } from '@/constants/modulesTv';

export const isClientDebtPayment = (debtPayment) => {
  if (debtPayment && debtPayment.deuda) {
    return true;
  }
  return false;
};

export const checkFakeEmail = (email) => {
  let isFake = false;
  const pattern2 = '@movistar.es';
  const pattern3 = 'notiene@';
  const pattern4 = '@telefonica.es';
  const pattern5 = 'ñ';

  if (
    email &&
    (EMAILMPLUS_FAKE_REGEX.test(email) ||
      email.indexOf(pattern2) !== -1 ||
      email.indexOf(pattern3) !== -1 ||
      email.indexOf(pattern4) !== -1 ||
      email.indexOf(pattern5) !== -1)
  ) {
    isFake = true;
  }

  return isFake;
};

export const getLabelChangeBillAddress = (addresses) => {
  let label = "";
  if (addresses && Array.isArray(addresses)){
    if (addresses.length === 1 && addresses[0].address) {
      label = addresses[0].address
    } else if (addresses.length > 1) {
      const moreThanOneAddress = addresses.filter((item) => item.type === TYPE_N3);
      if (moreThanOneAddress && Array.isArray(moreThanOneAddress) && moreThanOneAddress.length === 1 && moreThanOneAddress[0].address) {
        label = moreThanOneAddress[0].address;
      } else if (moreThanOneAddress && Array.isArray(moreThanOneAddress) && moreThanOneAddress.length > 1) {
        label = "Tienes varias direcciones";
      }
    }
  }
  return label;
}

export const getSlectesAddress = (addresses) => {
  let address = null;
  if (addresses && Array.isArray(addresses)) {
    const addressToShow = addresses.filter((item) => item.type === TYPE_N3);
    if (addressToShow && Array.isArray(addressToShow) && addressToShow.length === 1) {
      address = addressToShow[0].id
    }
  } 
  return address;
}

export const getPhoneList = (contactSMS) => {
  if (contactSMS && Array.isArray(contactSMS) && contactSMS.length > 0) {
    const phoneArray = contactSMS.map((phone) => {
      const { id, value, contactTypeTCOL, advertisingUse, favourite } = phone;
      return (
        { label: value, value: id, contactTypeTCOL, advertisingUse, favourite }
      )
    })
    return phoneArray;
  }
}

export const getFavoritePhone = (contactSMS) => {
  if (contactSMS && Array.isArray(contactSMS) && contactSMS.length > 0) {
    const phone = contactSMS.find((phone) => phone?.favourite === true);
    if (phone) {
      const { id, value, contactTypeTCOL, advertisingUse, favourite } = phone;
      return (
        { label: value, value: id, contactTypeTCOL, advertisingUse, favourite }
      )
    }
  }
}

export const getContactOptionsODB = (clientInfo) => {
  const options = [];
  const dictionaryNumbersUsr = {};

  if (clientInfo) {
    const { contactEmail, contactsSMS } = clientInfo;
    if (contactEmail) {
      options.push({
        label: contactEmail?.value,
        value: {
          verifiedContactMeanId: contactEmail?.id,
          subscribedLineId: null,
          contactTypeTCOL: '4',
          verified: contactEmail?.verifiable,
        },
      });
      dictionaryNumbersUsr[contactEmail?.id] = {
        name: contactEmail?.value,
        type: 'EMAIL',
      };   
    }
    if (contactsSMS && Array.isArray(contactsSMS) && contactsSMS.length > 0) {
      contactsSMS.forEach((item) => {
        if (item) {
          options.push({
            label: item?.value,
            value: {
              verifiedContactMeanId: item?.id,
              subscribedLineId: null,
              contactTypeTCOL: '2',
              verified: item?.verifiable,
            },
          });
          dictionaryNumbersUsr[item?.id] = {
            name: item?.value,
            type: 'SMS',
          };
        }
      });
    }
  }

  return { options, dictionaryNumbersUsr }
}

export const hasMimoClient = ({ userInfo }) =>
  userInfo?.userBundle?.some(
    (bundle) =>
      bundle?.pot?.some(
        ({ id }) =>
          id === PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID
      )
  ) ?? false;

export const checkIsEmail = (contact) =>
  contact?.value?.contactTypeTCOL === CONTACT_TYPES.EMAI?.contactTypeTCOL;

export const getInputConfig = (isEmail, index) =>
  isEmail
    ? {
        type: "email",
        id: `change-email-input-${index}`,
        placeholder: "Introduce un correo electrónico",
        title: "Email",
      }
    : {
        type: "tel",
        id: `change-tel-input-${index}`,
        placeholder: "Introduce un número de teléfono",
        title: "Móvil de contacto",
      };

export const validateContactInput = (contactText, currentLabel) => {
  const isValidPhone = Boolean(contactText && MOV_REGEX.test(contactText));
  const isValidEmail = Boolean(contactText && EMAIL_REGEX.test(contactText));
  const hasChanged = contactText !== currentLabel;

  return {
    isValid: (isValidEmail || isValidPhone) && hasChanged,
    typeCode: isValidEmail ? "4" : "2",
  };
};

export const buildVerifyContactPayload = (contactText, targetType) => ({
  contactType: targetType.contactType,
  contactTypeTCOL: targetType.contactTypeTCOL,
  value: contactText,
  favourite: true,
  advertisingUse: true,
  address: { id: null, locationFullAddress: null },
});